const overview = () => {
    $(".service-slide-advantages .advantages-slide").slick({
        dots: false,
        infinite: true,
        speed: 500,
        cssEase: 'linear',
        autoplay: false,
        autoplaySpeed: 5000,
        centerMode: true,
        arrows: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                arrows: true
                //fade: true,
            }
        }
        ],

    });
}

module.exports = overview